import { SearchFlightsState } from './getNextFlights.types'

const initialState: SearchFlightsState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
